export default "__VITE_ASSET__CAMo3Ur9__"